// React Router v5
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PageLoader from 'b2b/components/PageLoader';

const baseBadge = {
  margin: '5px',
  padding: '25px 30px',
  cursor: 'pointer',
  borderRadius: '0.35rem',
  fontWeight: 600,
  width: '25%',
  fontSize: '14px',
  fontWeight: '300',
};

// const STEP_ORDER = ['/b2b/selection', '/b2b/paiement', '/b2b/confirmation'];
const isB2BMode = () => !!localStorage.getItem('token_b2b'); // ou ton helper

export default function StepNav(props) {
  const loc = useLocation();
  const { state = {} } = loc;
  const history = useHistory();

  const isB2B = isB2BMode();

  const STEP_ORDER = isB2B
    ? ['/b2b/selection', '/b2b/paiement', '/b2b/confirmation']
    : ['/selection', '/paiement', '/confirmation'];

  const product = props.product || state.product || {};
  const search = props.search || state.search || {};
  const formData = props.formData || state.formData || null;
  const bookingId = props.bookingId || state.bookingId || null;

  const rawId = props.productId || state.productId || product._id || product.id;
  const productDbId = /^[a-f0-9]{24}$/i.test(String(rawId || '')) ? String(rawId) : null;
  console.log('%csrc\b2bcomponentsStepNav.jsx:38 productDbId', 'color: #007acc;', productDbId);
  const productCode =
    props.productCode ||
    state.productCode ||
    product.code ||
    product.productCode ||
    product._$id ||
    null;

  console.log('%csrc\b2bcomponentsStepNav.jsx:47 productCode', 'color: #007acc;', productCode);

  const pathname = loc.pathname;
  const isActive = (p) => pathname.startsWith(p);

  const [showLoader, setShowLoader] = useState(false);
  const [lockClicks, setLockClicks] = useState(false);

  // index de l’étape courante (/selection, /paiement/:id, /confirmation/:id)
  const currentStepIndex = STEP_ORDER.findIndex((p) => pathname.startsWith(p));

  const canGoToPaiement = bookingId && currentStepIndex >= STEP_ORDER.indexOf('/b2b/paiement');

  const canGoToConfirmation =
    bookingId && currentStepIndex >= STEP_ORDER.indexOf('/b2b/confirmation');

  useEffect(() => {
    if (showLoader) {
      const t = setTimeout(() => {
        setShowLoader(false);
        setLockClicks(false);
      }, 150);
      return () => clearTimeout(t);
    }
  }, [pathname, showLoader]);

  // 👉 même fonction go, mais on empêche d’aller "plus loin" que l’étape actuelle
  const go = (path) => {
    if (lockClicks) return;

    // on regarde dans quelle "étape" on veut aller
    const targetStepIndex = STEP_ORDER.findIndex((p) => path.startsWith(p));

    // si on essaie d’aller à une étape plus avancée (ex: de /selection vers /paiement),
    // on bloque le clic
    if (
      targetStepIndex !== -1 &&
      currentStepIndex !== -1 &&
      targetStepIndex > currentStepIndex
    ) {
      return; // 🔒 clic ignoré, l'utilisateur doit utiliser le bouton "Continuer vers paiement"
    }

    setLockClicks(true);
    setShowLoader(true);

    history.push(path, {
      ...state,
      bookingId,
      ...(isB2B ? { productId: productDbId } : { productCode }), // ✅
      product,
      search,
      formData,
    });
  };
  const goBackToProduct = () => {
    const isB2B = isB2BMode();

    setLockClicks(true);
    setShowLoader(true);

    // ✅ B2B: mongo id
    if (isB2B && productDbId) {
      const productPath = `/b2b/produit/${productDbId}`;
      history.push(productPath, {
        ...state,
        bookingId,
        productId: productDbId,
        product: undefined,
        search,
        formData,
      });
      return;
    }

    // ✅ B2C: productCode
    if (!isB2B && productCode) {
      const productPath = `/produit/${productCode}`;
      history.push(productPath, {
        ...state,
        bookingId,
        productCode,
        product: undefined,
        search,
        formData,
      });
      return;
    }

    // fallback
    history.goBack();
  };

  // helpers pour les URLs avec bookingId
  // const isB2B = !!localStorage.getItem('token_b2b');

  const paiementPath = bookingId
    ? isB2B
      ? `/b2b/paiement/${bookingId}`
      : `/paiement/${bookingId}`
    : isB2B
    ? '/b2b/paiement'
    : '/paiement';

  const confirmationPath = bookingId
    ? isB2B
      ? `/b2b/confirmation/${bookingId}`
      : `/confirmation/${bookingId}`
    : isB2B
    ? '/b2b/confirmation'
    : '/confirmation';

  return (
    <>
      {showLoader && <PageLoader open={true} text="Chargement de la page..." />}

      <div className="mb-3">
        <div className="d-inline-flex gap-2" style={{ width: '100%' }}>
          {/* RETOUR AU PRODUIT */}
          <span
            className={`badge bg-light text-dark border ${
              pathname.startsWith('/b2b/produit/') ? 'active' : ''
            }`}
            style={baseBadge}
            onClick={goBackToProduct}
            role="button"
            tabIndex={0}
          >
            RETOUR AU PRODUIT
          </span>

          {/* DEVIS */}
          <span
            className={`badge bg-light text-dark border ${
              isActive('/b2b/selection') ? 'active' : ''
            }`}
            style={baseBadge}
            onClick={() => go(isB2B ? '/b2b/selection' : '/selection')}
            role="button"
            tabIndex={0}
          >
            DEVIS
          </span>

          {/* PAIEMENT : seulement si on n’avance pas de step, et bookingId connu */}
          <span
            className={`badge bg-light text-dark border ${
              isActive('/b2b/paiement') ? 'active' : ''
            }`}
            style={{
              ...baseBadge,
              opacity: canGoToPaiement ? 1 : 0.4,
              cursor: canGoToPaiement ? 'pointer' : 'not-allowed',
              pointerEvents: canGoToPaiement ? 'auto' : 'none',
            }}
            onClick={() => canGoToPaiement && go(paiementPath)}
          >
            PAIEMENT
          </span>

          {/* CONFIRMATION */}
          <span
            className={`badge bg-light text-dark border ${
              isActive('/b2b/confirmation') ? 'active' : ''
            }`}
            style={{
              ...baseBadge,
              opacity: canGoToConfirmation ? 1 : 0.4,
              cursor: canGoToConfirmation ? 'pointer' : 'not-allowed',
              pointerEvents: canGoToConfirmation ? 'auto' : 'none',
            }}
            onClick={() => canGoToConfirmation && go(confirmationPath)}
          >
            CONFIRMATION
          </span>
        </div>

        <style>{`
          .badge.active {
            background:#000064 !important;
            color:#fff !important;
            border-color:#000064 !important;
          }
        `}</style>
      </div>
    </>
  );
}
